import React from 'react';

import {Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import Room from "./Room";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import MessengerSidebar from "./MessengerSidebar";


class Messenger extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            roomSubscriber: null,
            displayMenu: false,

        }
        this.menuRef = React.createRef()
    }

    async componentDidMount() {
    }

    componentWillUnmount() {
    }

    setRoomSubscriber(roomSubscriber){
        this.setState(
            {
                roomSubscriber: null,
            }
        )
        this.setState(
            {
                roomSubscriber: roomSubscriber,
            }
        )
    }
    async createCallBack(room){
        if (room){
            const url = 'room_subscriber/';
            const params = {
                subscriber: this.context.subscriberObject.id,
                room: room,
                page_size: 10000,
            };
            const api = new BaseApi();
            let response = await api.get(
                url,
                params
            );
            if (response.data?.results){
                let roomSubscriber = response.data.results[0]
                this.setRoomSubscriber(roomSubscriber)
            }
        }
    }

    openMenu(){
        this.setState(
            {
                roomSubscriber: null,
            }
        )
        this.menuRef?.current?.openMenu()
    }


    render() {
        return (
            <Stack
                direction={'row'}
                sx={{
                    height: '100%'
                }}
                spacing={{
                    xs: 0,
                    md: 2,
                }}
            >
                <MessengerSidebar
                    setRoomSubscriberCallBack={this.setRoomSubscriber.bind(this)}
                    createCallBack={this.createCallBack.bind(this)}
                    ref={this.menuRef}
                />
                <Stack
                    sx={{
                        height: '100%',
                        maxWidth: '100%',
                        flexGrow: 2,
                        width: {
                            xs: '100%',
                            lg: 'calc(100% - 300px)'
                        }
                    }}
                >
                    <Room
                        key={'Room' + this.state.roomSubscriber?.id}
                        roomSubscriber={this.state.roomSubscriber}
                        menuCallBack={this.openMenu.bind(this)}
                    />
                </Stack>
            </Stack>
        )
    }
}

export default Messenger;
